import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Avatar,
  Card,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  Stack,
  Grid,
  CircularProgress,
  Box,
  FormControlLabel,
  alpha,
} from "@mui/material";
import { motion } from "framer-motion";
import { Add } from "@mui/icons-material";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";

import CustomButton from "../../components/mui/CustomButton";
import RModal from "../../components/mui/RModal";
import InputField1 from "../../components/mui/InputField1";
import { enqueueSnackbar } from "notistack";

import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import {
  deleteBackenUser,
  updateUser,
  userAdd,
} from "../../actions/backEndUserAuth";
import { getAllUsersClient } from "../../actions/userAuth";
import { hasRole } from "../../utils/roleUtils";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useNavigate } from "react-router-dom";
import SelectDropdown from "../../components/mui/SelectDropdown";
import IOSSwitch from "../../style/globalStyles";
import SearchBar from "../../components/mui/SearchBar";
import ResponsiveDatePickers from "../../components/mui/PichDate";
import dayjs from "dayjs";
const columns = [
  "User",
  "Email",
  "Phone",
  "Access",
  "Last login",
  "Actions",
];

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.04, duration: 0.45, ease: [0.22, 1, 0.36, 1] },
  }),
};

const PanelCard = ({ children, sx = {} }) => (
  <Card
    elevation={0}
    sx={{
      borderRadius: "24px",
      border: "1px solid",
      borderColor: alpha("#11409B", 0.08),
      bgcolor: "#fff",
      boxShadow: "0 4px 32px rgba(15, 23, 42, 0.06)",
      overflow: "hidden",
      ...sx,
    }}
  >
    {children}
  </Card>
);

const StatCard = ({ icon: Icon, label, value, accent, gradient }) => (
  <PanelCard sx={{ height: "100%" }}>
    <Box sx={{ p: 2.5, position: "relative", overflow: "hidden" }}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "14px",
            background: gradient,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: `0 8px 24px ${alpha(accent, 0.35)}`,
          }}
        >
          <Icon sx={{ color: "#fff", fontSize: 24 }} />
        </Box>
        <Box>
          <Typography
            variant="caption"
            sx={{
              color: "#64748b",
              fontWeight: 600,
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              fontSize: "0.7rem",
            }}
          >
            {label}
          </Typography>
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: "1.75rem",
              color: "#0f172a",
              letterSpacing: "-0.03em",
              lineHeight: 1.1,
            }}
          >
            {value}
          </Typography>
        </Box>
      </Stack>
    </Box>
  </PanelCard>
);

const getInitials = (name, email) => {
  const src = name || email || "?";
  return src.charAt(0).toUpperCase();
};

const categories = [
  { name: "Order management", value: "Order management" },
  { name: "Brand management", value: "Brand management" },
  { name: "Client management", value: "Client management" },
  { name: "Ticket management", value: "Ticket management" },
  { name: "Sales management", value: "Sales management" },
  { name: "Banner management", value: "Banner management" },
];
export const BackendUser = () => {
  const [open, setOpen] = useState(false);
  const [openSecondModal, setOpenSecondModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [countPerPage, setCountPerPage] = useState(10);
  const { user } = useSelector((state) => ({ ...state }));
  const [selectedRolesAdd, setSelectedRolesAdd] = useState([]);

  const allUsers = useSelector((state) => state.allUsers);
  console.log("all user is", allUsers);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const roleDropdownRef = useRef(null);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      Navigate("/");
    }
  }, []);

  useEffect(() => {
    console.log("User ID:", user);
  }, [user]);

  const userId = user.id;

  const fetchAdminUsers = () => {
    setLoading(true);
    dispatch(
      getAllUsersClient(
        { page: 1, perPage: 100000 },
        (data) => {
          const allUsers = data?.data?.data?.users || [];
          const adminUsers = allUsers.filter((item) => hasRole(item, "ADMIN"));
          const filteredData = adminUsers.filter((item) => {
            const matchQuery =
              item?.username
                ?.toLowerCase()
                ?.includes(searchTerm?.toLowerCase()) ||
              item?.gender
                ?.toLowerCase()
                ?.includes(searchTerm?.toLowerCase()) ||
              item?.phone?.includes(searchTerm) ||
              item?.email?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
              item?.lastLogin
                ?.toLowerCase()
                ?.includes(searchTerm?.toLowerCase());

            const matchDateRange =
              (!dateFrom || new Date(item.updatedAt) >= new Date(dateFrom)) &&
              (!dateTo || new Date(item.updatedAt) <= new Date(dateTo));

            return matchQuery && matchDateRange;
          });

          filteredData.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );

          setUsers(filteredData);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  };

  useEffect(() => {
    setLoading(true);
    fetchAdminUsers();
  }, [dispatch, countPerPage, currentPage, searchTerm, dateFrom, dateTo]);

  const [formDataEdit, setFormDataEdit] = useState({
    email: "",
    phone: "",
    username: "",
    hasAccessTo: [],
  });

  const [formDataAdd, setFormDataAdd] = useState({
    name: "",
    email: "",
    phone: "",
    username: "",
    password: "",
    profile: "",
    hasAccessTo: [],
  });

  const handleOpen = (user) => {
    setOpen(true);
    if (user) {
      setFormDataEdit({
        id: user.id,
        username: user.username,
        phone: user.phone,
        email: user.email,
        hasAccessTo: Array.isArray(user.hasAccessTo)
          ? user.hasAccessTo
          : user.hasAccessTo
          ? [user.hasAccessTo]
          : [],
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenSecondModal = () => {
    setFormDataAdd({
      name: "",
      email: "",
      phone: "",
      username: "",
      password: "",
      profile: "",
      hasAccessTo: [],
    });
    setSelectedRolesAdd([]);
    setOpenSecondModal(true);
  };

  const handleCloseSecondModal = () => {
    setOpenSecondModal(false);
  };

  const handleCouponDataChange = (name, value) => {
    setFormDataEdit((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleCouponDataChange1 = (name, value) => {
    if (name === "hasAccessTo") {
      setFormDataAdd((prevData) => ({
        ...prevData,
        hasAccessTo: Array.isArray(value) ? value : value ? [value] : [],
      }));
    } else {
      setFormDataAdd((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleEdit = (event) => {
    event.preventDefault();
    setLoading(true);

    dispatch(
      updateUser(
        formDataEdit?.id,
        formDataEdit,

        (response) => {
          enqueueSnackbar("Data submitted successfully", {
            variant: "success",
          });

          fetchAdminUsers();

          handleClose();
          setLoading(false);
        },
        (error) => {
          console.log(error);
          enqueueSnackbar(
            error?.response?.data?.message,

            {
              variant: "error",
            }
          );
        }
      )
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    const normalizedUsername = (formDataAdd.username || "").trim();
    const payload = {
      name: normalizedUsername,
      email: formDataAdd.email,
      phone: formDataAdd.phone,
      username: normalizedUsername,
      password: formDataAdd.password,
      profile: formDataAdd.profile,
      permissions: Array.isArray(formDataAdd.hasAccessTo)
        ? formDataAdd.hasAccessTo
        : [],
    };
    dispatch(
      userAdd(
        userId,
        payload,
        (response) => {
          enqueueSnackbar("Data submitted successfully", {
            variant: "success",
          });

          setLoading(false);
          handleCloseSecondModal();
          fetchAdminUsers();
          setSelectedRolesAdd([]);
        },
        (error) => {
          enqueueSnackbar(
            error?.response?.data?.message || "Error submitting data",
            {
              variant: "error",
            }
          );
          console.log(error);
        }
      )
    );
  };
  const handleReset = () => {
    setFormDataAdd({
      name: "",
      email: "",
      phone: "",
      username: "",
      password: "",
      profile: "",
      hasAccessTo: [],
    });
    setSelectedRolesAdd([]);
    if (roleDropdownRef.current) {
      roleDropdownRef.current.reset();
    }
  };
  const handleDelete = (id) => {
    dispatch(
      deleteBackenUser(
        userId,
        id,
        (data) => {
          enqueueSnackbar("Delete Successfully", {
            variant: "success",
          });
          fetchAdminUsers();
        },
        (err) => {
          enqueueSnackbar("Error Occured! Please try again", {
            variant: "error",
          });
        }
      )
    );
  };

  const handleExport = () => {
    const formattedData = users.map((user) => ({
      Username: user.username,
      Email: user.email,
      Phone: user.phone,
      Role: Array.isArray(user.hasAccessTo)
        ? user.hasAccessTo.join(", ")
        : user.hasAccessTo || "--",
      "Last Login Date": new Date(user.updatedAt).toLocaleDateString("en-IN"),
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Users");

    XLSX.writeFile(wb, "BackendUsers.xlsx");
  };

  const updateUserStatus = (id, status, email) => {
    console.log("email", email);
    const payload = {
      active: status,
      email: email,
    };

    dispatch(
      updateUser(
        userId,
        { id, ...payload },
        (response) => {
          enqueueSnackbar("User status updated successfully", {
            variant: "success",
          });
          fetchAdminUsers();
        },
        (error) => {
          enqueueSnackbar("Error updating user status", {
            variant: "error",
          });
          console.error(error);
        }
      )
    );
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };

  const handleSearchClear = () => {
    setSearchTerm("");
    setDateFrom(null);
    setDateTo(null);
  };

  const paginatedData = users.slice(
    (currentPage - 1) * countPerPage,
    currentPage * countPerPage
  );

  const totalPages = Math.ceil(users.length / countPerPage) || 1;

  const stats = useMemo(() => {
    const total = users.length;
    const active = users.filter((u) => u.active).length;
    return { total, active, inactive: total - active };
  }, [users]);

  const premiumButtonSx = {
    height: "44px",
    borderRadius: "12px",
    fontWeight: 600,
    textTransform: "none",
    background: "linear-gradient(135deg, #11409B 0%, #2563eb 100%)",
    boxShadow: "0 6px 24px rgba(37, 99, 235, 0.35)",
    "&:hover": {
      background: "linear-gradient(135deg, #0f3580 0%, #1d4ed8 100%)",
    },
  };

  return (
    <>
      <Grid container spacing={2.5} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={4}>
          <motion.div custom={0} initial="hidden" animate="visible" variants={fadeUp}>
            <StatCard
              icon={GroupsOutlinedIcon}
              label="Total managers"
              value={stats.total}
              accent="#4f46e5"
              gradient="linear-gradient(135deg, #818cf8 0%, #4f46e5 100%)"
            />
          </motion.div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <motion.div custom={1} initial="hidden" animate="visible" variants={fadeUp}>
            <StatCard
              icon={PersonOutlineOutlinedIcon}
              label="Active"
              value={stats.active}
              accent="#059669"
              gradient="linear-gradient(135deg, #34d399 0%, #059669 100%)"
            />
          </motion.div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <motion.div custom={2} initial="hidden" animate="visible" variants={fadeUp}>
            <StatCard
              icon={PersonOffOutlinedIcon}
              label="Inactive"
              value={stats.inactive}
              accent="#64748b"
              gradient="linear-gradient(135deg, #94a3b8 0%, #64748b 100%)"
            />
          </motion.div>
        </Grid>
      </Grid>

      <motion.div custom={3} initial="hidden" animate="visible" variants={fadeUp}>
        <PanelCard sx={{ mb: 3, p: { xs: 2, md: 2.5 } }}>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            spacing={2}
            mb={2}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <FilterListOutlinedIcon sx={{ color: "#11409B", fontSize: 20 }} />
              <Typography sx={{ fontWeight: 700, color: "#0f172a" }}>
                Filters & actions
              </Typography>
            </Stack>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} width={{ xs: "100%", sm: "auto" }}>
              <CustomButton
                variant="contained"
                onClick={handleExport}
                startIcon={<FileDownloadOutlinedIcon />}
                sx={premiumButtonSx}
              >
                Export
              </CustomButton>
              <CustomButton
                variant="contained"
                onClick={handleOpenSecondModal}
                startIcon={<Add />}
                sx={premiumButtonSx}
              >
                Add user
              </CustomButton>
            </Stack>
          </Stack>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <SearchBar
                onSearch={handleSearch}
                onClear={handleSearchClear}
                searchTerm={searchTerm}
                height="2.75rem"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <ResponsiveDatePickers
                selectedDate={dateFrom}
                setSelectedDate={setDateFrom}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CustomButton
                variant="outlined"
                onClick={handleSearchClear}
                fullWidth
                sx={{
                  height: "2.75rem",
                  borderRadius: "12px",
                  textTransform: "none",
                  fontWeight: 600,
                  borderColor: alpha("#11409B", 0.25),
                  color: "#11409B",
                  "&:hover": {
                    borderColor: "#11409B",
                    bgcolor: alpha("#11409B", 0.04),
                  },
                }}
              >
                Clear
              </CustomButton>
            </Grid>
          </Grid>
        </PanelCard>
      </motion.div>

      <motion.div custom={4} initial="hidden" animate="visible" variants={fadeUp}>
        {loading ? (
          <PanelCard>
            <Stack alignItems="center" justifyContent="center" sx={{ py: 10 }}>
              <CircularProgress sx={{ color: "#11409B" }} />
              <Typography sx={{ mt: 2, color: "#64748b" }}>
                Loading managers…
              </Typography>
            </Stack>
          </PanelCard>
        ) : paginatedData.length > 0 ? (
          <TableContainer component={PanelCard} sx={{ overflowX: "auto" }}>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    bgcolor: alpha("#11409B", 0.04),
                    "& th": {
                      borderBottom: `1px solid ${alpha("#11409B", 0.08)}`,
                    },
                  }}
                >
                  {columns.map((column) => (
                    <TableCell
                      key={column}
                      sx={{
                        fontSize: "0.75rem",
                        fontWeight: 700,
                        color: "#11409B",
                        textTransform: "uppercase",
                        letterSpacing: "0.06em",
                        py: 2,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {column}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      transition: "background 0.2s",
                      "&:hover": { bgcolor: alpha("#11409B", 0.03) },
                      "& td": {
                        borderBottom: `1px solid ${alpha("#11409B", 0.06)}`,
                        py: 1.75,
                      },
                    }}
                  >
                    <TableCell>
                      <Stack direction="row" alignItems="center" spacing={1.5}>
                        <Avatar
                          sx={{
                            width: 44,
                            height: 44,
                            background:
                              "linear-gradient(135deg, #11409B, #2563eb)",
                            fontWeight: 700,
                            border: "2px solid #fff",
                            boxShadow: "0 4px 12px rgba(17,64,155,0.2)",
                          }}
                        >
                          {getInitials(row.username, row.email)}
                        </Avatar>
                        <Typography sx={{ fontWeight: 600, color: "#0f172a" }}>
                          {row.username || "—"}
                        </Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ color: "#475569" }}>
                        {row.email || "—"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ color: "#475569" }}>
                        {row.phone ? `+91 ${row.phone}` : "—"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" flexWrap="wrap" gap={0.5} maxWidth={220}>
                        {(Array.isArray(row.hasAccessTo)
                          ? row.hasAccessTo
                          : row.hasAccessTo
                          ? [row.hasAccessTo]
                          : []
                        ).map((role) => (
                          <Chip
                            key={role}
                            label={role}
                            size="small"
                            sx={{
                              bgcolor: alpha("#11409B", 0.08),
                              color: "#11409B",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                            }}
                          />
                        ))}
                        {!row.hasAccessTo ||
                        (Array.isArray(row.hasAccessTo) &&
                          row.hasAccessTo.length === 0) ? (
                          <Typography variant="body2" sx={{ color: "#94a3b8" }}>
                            —
                          </Typography>
                        ) : null}
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ color: "#64748b" }}>
                        {row?.updatedAt
                          ? dayjs(row.updatedAt).format("DD MMM YYYY")
                          : "—"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" alignItems="center" spacing={0.5}>
                        <Chip
                          label={row.active ? "Active" : "Inactive"}
                          size="small"
                          sx={{
                            bgcolor: row.active
                              ? alpha("#16a34a", 0.12)
                              : alpha("#64748b", 0.12),
                            color: row.active ? "#16a34a" : "#64748b",
                            fontWeight: 700,
                            fontSize: "0.7rem",
                          }}
                        />
                        <IconButton
                          onClick={() => handleDelete(row?.id)}
                          size="small"
                          sx={{ borderRadius: "10px" }}
                        >
                          <img src="/liDelet.svg" alt="Delete" />
                        </IconButton>
                        <IconButton
                          onClick={() => handleOpen(row)}
                          size="small"
                          sx={{ borderRadius: "10px" }}
                        >
                          <img src="/liEdit.svg" alt="Edit" />
                        </IconButton>
                        <FormControlLabel
                          sx={{ m: 0 }}
                          control={
                            <IOSSwitch
                              checked={row.active}
                              onChange={(e) =>
                                updateUserStatus(
                                  row.id,
                                  e.target.checked,
                                  row.email
                                )
                              }
                            />
                          }
                          label=""
                        />
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <PanelCard>
            <Stack alignItems="center" sx={{ py: 8, px: 3 }}>
              <GroupsOutlinedIcon sx={{ fontSize: 56, color: "#cbd5e1", mb: 2 }} />
              <Typography variant="h6" sx={{ fontWeight: 700, color: "#0f172a" }}>
                No managers found
              </Typography>
              <Typography sx={{ color: "#64748b", mt: 1, textAlign: "center" }}>
                Try adjusting your search or add a new manager.
              </Typography>
            </Stack>
          </PanelCard>
        )}
      </motion.div>

      {!loading && users.length > 0 && (
        <motion.div custom={5} initial="hidden" animate="visible" variants={fadeUp}>
          <PanelCard sx={{ mt: 3, p: 2 }}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              alignItems="center"
              justifyContent="space-between"
              spacing={2}
            >
              <Typography sx={{ color: "#64748b", fontWeight: 500 }}>
                Showing {(currentPage - 1) * countPerPage + 1}–
                {Math.min(currentPage * countPerPage, users.length)} of{" "}
                {users.length}
              </Typography>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography variant="body2" sx={{ color: "#64748b" }}>
                  Rows per page
                </Typography>
                <Box
                  component="select"
                  value={countPerPage}
                  onChange={(e) => {
                    setCountPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                  sx={{
                    border: `1px solid ${alpha("#11409B", 0.2)}`,
                    borderRadius: "10px",
                    px: 1.5,
                    py: 0.75,
                    fontSize: "0.875rem",
                    color: "#0f172a",
                    bgcolor: "#fff",
                    outline: "none",
                  }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                </Box>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                    sx={{
                      border: "1px solid",
                      borderColor: alpha("#11409B", 0.15),
                      borderRadius: "12px",
                      bgcolor: "#fff",
                      "&:hover": { bgcolor: alpha("#11409B", 0.06) },
                    }}
                  >
                    <KeyboardArrowLeftIcon />
                  </IconButton>
                  <Typography sx={{ fontWeight: 600, minWidth: 48, textAlign: "center" }}>
                    {currentPage} / {totalPages}
                  </Typography>
                  <IconButton
                    onClick={() =>
                      setCurrentPage((p) => Math.min(p + 1, totalPages))
                    }
                    disabled={currentPage >= totalPages}
                    sx={{
                      border: "1px solid",
                      borderColor: alpha("#11409B", 0.15),
                      borderRadius: "12px",
                      bgcolor: "#fff",
                      "&:hover": { bgcolor: alpha("#11409B", 0.06) },
                    }}
                  >
                    <KeyboardArrowRightIcon />
                  </IconButton>
                </Stack>
              </Stack>
            </Stack>
          </PanelCard>
        </motion.div>
      )}

      {open && (
        <RModal
          open={open}
          handleClose={handleClose}
          width={{ xl: "60%", sm: "80%", xs: "80%" }}
          height="auto"
        >
          <form onSubmit={handleEdit}>
            <Typography variant="h4">Update Admin </Typography>

            <Grid container spacing={{ xl: 1, sm: 0, xs: 0 }}>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Name"}
                  placeholder={"Enter Name"}
                  spanP={true}
                  onChange={(e) =>
                    handleCouponDataChange1("name", e.target.value)
                  }
                  required
                  maxLength={50}
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"User Name"}
                  placeholder={"Enter User Name"}
                  spanP={true}
                  value={formDataEdit.username}
                  onChange={(e) =>
                    handleCouponDataChange("username", e.target.value)
                  }
                  required
                  maxLength={20}
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Email"}
                  placeholder={"Enter Email"}
                  spanP={true}
                  value={formDataEdit.email}
                  onChange={(e) =>
                    handleCouponDataChange("email", e.target.value)
                  }
                  required
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Password"}
                  placeholder={"Enter Password"}
                  spanP={true}
                  type={"password"}
                  onChange={(e) =>
                    handleCouponDataChange1("password", e.target.value)
                  }
                  required
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Profile URL"}
                  placeholder={"Enter Profile URL"}
                  spanP={true}
                  onChange={(e) =>
                    handleCouponDataChange1("profile", e.target.value)
                  }
                  required
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Mobile Number"}
                  placeholder={"Enter Mobile Number"}
                  spanP={true}
                  value={formDataEdit.phone}
                  onChange={(e) =>
                    handleCouponDataChange("phone", e.target.value)
                  }
                  required
                  maxLength={10}
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <Typography mt={1.5} mb={1.5}>
                  Role
                </Typography>
                <SelectDropdown
                  ref={roleDropdownRef}
                  menuItems={categories.map((item) => ({
                    value: item.value,
                    label: item.name,
                  }))}
                  selectedItem={formDataEdit.hasAccessTo || []}
                  setSelectedItem={(items) => {
                    handleCouponDataChange(
                      "hasAccessTo",
                      Array.isArray(items) ? items : items ? [items] : []
                    );
                  }}
                  isMulti={true}
                  buttonText={"Select role(s)"}
                  buttonWidth={"100%"}
                  height={"2.7rem"}
                  borderRadius={".5rem"}
                />
              </Grid>
            </Grid>
            <Stack
              direction={"row"}
              spacing={{ xl: 6, md: 6, sm: 1, xs: 1 }}
              mt={4}
            >
              {" "}
              <CustomButton
                variant="contained"
                width={{
                  xl: "20vh",
                  md: "50%",
                  sm: "50%",
                  xs: "60%",
                }}
                height={"3rem"}
                type="submit"
              >
                {loading ? <CircularProgress size={24} /> : "Update "}
              </CustomButton>
              {/* <CustomButton
                variant='outlined'
                width={{ xl: '20vh', md: '50%', sm: '50%', xs: '40%' }}
                height={'3rem'}
                type='reset'
              >
                Reset
              </CustomButton> */}
            </Stack>
          </form>
        </RModal>
      )}
      {openSecondModal && (
        <RModal
          open={openSecondModal}
          handleClose={handleCloseSecondModal}
          width={{ xl: "60%", sm: "80%", xs: "80%" }}
          height="auto"
        >
          <form onSubmit={handleSubmit}>
            <Typography variant="h4">Add Admin</Typography>

            <Grid container spacing={{ xl: 1, sm: 0, xs: 0 }}>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"User Name"}
                  placeholder={"Enter User Name"}
                  spanP={true}
                  onChange={(e) =>
                    handleCouponDataChange1("username", e.target.value)
                  }
                  required
                  maxLength={20}
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Email"}
                  placeholder={"Enter Email"}
                  spanP={true}
                  onChange={(e) =>
                    handleCouponDataChange1("email", e.target.value)
                  }
                  required
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Mobile Number"}
                  placeholder={"Enter Mobile Number"}
                  spanP={true}
                  onChange={(e) =>
                    handleCouponDataChange1("phone", e.target.value)
                  }
                  required
                  maxLength={10}
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <Typography mt={1.5} mb={1.5}>
                  Role
                </Typography>
                <SelectDropdown
                  ref={roleDropdownRef}
                  menuItems={categories.map((item) => ({
                    value: item.value,
                    label: item.name,
                  }))}
                  selectedItem={selectedRolesAdd}
                  setSelectedItem={setSelectedRolesAdd}
                  isMulti={true}
                  buttonText={"Select role(s)"}
                  buttonWidth={"100%"}
                  height={"2.7rem"}
                  borderRadius={".5rem"}
                  onChange={(selectedValue) =>
                    handleCouponDataChange1("hasAccessTo", selectedValue)
                  }
                />
              </Grid>
            </Grid>
            <Stack
              direction={"row"}
              spacing={{ xl: 6, md: 6, sm: 1, xs: 1 }}
              mt={4}
            >
              <CustomButton
                variant="contained"
                width={{
                  xl: "20vh",
                  md: "50%",
                  sm: "50%",
                  xs: "60%",
                }}
                height={"3rem"}
                type="submit"
              >
                {loading ? <CircularProgress size={24} /> : "Add"}
              </CustomButton>
              <CustomButton
                variant="outlined"
                width={{
                  xl: "20vh",
                  md: "50%",
                  sm: "50%",
                  xs: "40%",
                }}
                height={"3rem"}
                type="reset"
                onClick={handleReset}
              >
                Reset
              </CustomButton>
            </Stack>
          </form>
        </RModal>
      )}
    </>
  );
};
